import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withProjectContextConsumer } from '~/modules/resourcing/common/contexts';
import {
  RequestActions,
  ResourceRequestBulkDeleteActions
} from '~/modules/resourcing/common/components';
import { useDialogState } from '~/modules/common/hooks';
import { useBulkDeleteResourceRequestsFromProject } from '~/modules/resourcing/common/hooks/useBulkDeleteResourceRequestsHandler';
import useResourceRequestBulkActions from './hooks/useResourceRequestBulkActions';

export const ResourceRequestBulkActions = ({
  classes,
  project,
  resourceRequests
}) => {
  const { open, closeDialog, openDialog } = useDialogState();
  const bulkDeleteResourceRequestsFromProject = useBulkDeleteResourceRequestsFromProject();

  const onDeleteClick = useCallback(() => {
    closeDialog();
    bulkDeleteResourceRequestsFromProject({ project, resourceRequests });
  }, [
    bulkDeleteResourceRequestsFromProject,
    closeDialog,
    project,
    resourceRequests
  ]);

  const { actions } = useResourceRequestBulkActions({
    resourceRequests,
    openRemoveDialog: openDialog,
    project
  });

  return (
    <>
      <RequestActions
        qeIdTag="RequestActions"
        classes={classes}
        actions={actions}
      />
      {open && (
        <ResourceRequestBulkDeleteActions
          showRemoveRequestsDialog={open}
          closeRemoveRequestsDialog={closeDialog}
          onDeleteRequestsClick={onDeleteClick}
        />
      )}
    </>
  );
};

ResourceRequestBulkActions.propTypes = {
  classes: PropTypes.object,
  project: PropTypes.object,
  resourceRequests: PropTypes.array
};

export default withProjectContextConsumer(ResourceRequestBulkActions);
